import { useContext, useEffect, useState } from "react";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { useLocation, useNavigate } from "react-router-dom";
import { routeNames } from "../../constants/routeNames";
import "./SimplePages.css";

export const Closed = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);
  const [data, setData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location?.state?.redirected) {
      navigate(routeNames.LANDING);
    }
    if (location?.state?.data?.maintenance && location?.state?.data?.title) {
      setTitle(location?.state?.data?.title);
    } else {
      setTitle("SORRY!");
    }
    setData(location?.state?.data);
    setLoading(false);
  }, []);

  return (
    <div className="simple-content ">
      {data?.maintenance && (
        <>
          <p className="simple-content-description">{data?.description}</p>
          <p className="simple-content-description">{data?.message}</p>
        </>
      )}

      {!data?.maintenance && (
        <>
          <p className="simple-content-description">
            This promotion is now finished.
          </p>
        </>
      )}
    </div>
  );
};
